export default "__VITE_ASSET__BDf2ltxM__"